import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import classNames from 'classnames';
import EditIcon from '../../resources/svg/edit.svg';
import css from './EditableTitle.css';

const EditableTitle = ({
    containerStyle = {},
    value = '',
    placeholder = '',
    error = null,
    containerClass = null,
    onTextChanged = () => null,
    onTextChangeComplete = () => null,
}) => {
    const [isEditSelected, setIsEditSelected] = useState(false);
    const eventNameInputRef = useRef(null);

    const handleClick = useCallback(
        e => {
            e.stopPropagation();

            if (!isEditSelected) {
                eventNameInputRef.current && eventNameInputRef.current.select();
            }

            setIsEditSelected(true);
        },
        [isEditSelected]
    );

    const handleBlur = useCallback(() => {
        setIsEditSelected(false);
        eventNameInputRef.current && eventNameInputRef.current.blur();
        onTextChangeComplete();
    }, [onTextChangeComplete]);

    const handleTextChanged = useCallback(() => {
        onTextChanged(eventNameInputRef.current ? eventNameInputRef.current.value : '');
    }, [onTextChanged]);

    const handleKeyPress = useCallback(
        e => {
            if (e.key === 'Enter') handleBlur();
        },
        [handleBlur]
    );

    return (
        <div
            className={classNames(css.editableTitleHolder, containerClass, {
                [css.inputSelected]: isEditSelected,
                [css.error]: error,
            })}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            style={containerStyle}
        >
            <input
                type="text"
                className={css.editableInput}
                ref={eventNameInputRef}
                onChange={handleTextChanged}
                value={value}
                maxLength={40}
                onBlur={handleBlur}
                placeholder={placeholder}
                onKeyPress={handleKeyPress}
            />
            <EditIcon className={css.pencil} />
            <span className={css.errorMessage}>{error}</span>
        </div>
    );
};

EditableTitle.propTypes = {
    onTextChanged: PropTypes.func,
    onTextChangeComplete: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    containerStyle: PropTypes.objectOf(PropTypes.any),
    error: PropTypes.string,
    containerClass: PropTypes.string,
};

export default withLocalize(EditableTitle);
